import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Nullable } from "../../../../../Types/Common";

interface IInitialState {
  isOpenDrawer: boolean;
  activeTabDrawer: string;
  selectedUserDrawer: {
    id: Nullable<number>;
    name: Nullable<string>;
    leaveDates: Nullable<Array<string>>;
  };
}

const initialState: IInitialState = {
  isOpenDrawer: false,
  activeTabDrawer: "leave",
  selectedUserDrawer: { id: null, name: null, leaveDates: null },
};

const attendanceLeaveCorrectionSlice = createSlice({
  name: "attendanceLeaveCorrection",
  initialState,
  reducers: {
    setIsOpenDrawer: (state, action: PayloadAction<boolean>) => {
      state.isOpenDrawer = action.payload;
    },
    setActiveTabDrawer: (state, action: PayloadAction<string>) => {
      state.activeTabDrawer = action.payload;
    },
    setSelectedUserDrawer: (
      state,
      action: PayloadAction<{
        id: Nullable<number>;
        name: Nullable<string>;
        leaveDates: Nullable<Array<string>>;
      }>
    ) => {
      state.selectedUserDrawer.id = action.payload.id;
      state.selectedUserDrawer.name = action.payload.name;
      state.selectedUserDrawer.leaveDates = action.payload.leaveDates;
    },
  },
});

export const { setIsOpenDrawer, setActiveTabDrawer, setSelectedUserDrawer } =
  attendanceLeaveCorrectionSlice.actions;

export default attendanceLeaveCorrectionSlice.reducer;
